// menuConfig.js

import {
  BellOutlined,
  DashboardOutlined,
  LoginOutlined,
  DatabaseOutlined,
  LogoutOutlined,
  ShoppingOutlined,
  CarOutlined,
  UsergroupAddOutlined,
  BarcodeOutlined,
} from "@ant-design/icons";

// Static role-based menu config (no dynamic conditionals here)
export const MENU_CONFIG = {
  office: [
    {
      label: "",
      key: "notifications",
      icon: <BellOutlined />,
      path: "/user/notification",
    },
    {
      label: "Dashboard",
      key: "dashboard",
      icon: <DashboardOutlined />,
      path: "/user/dashboard",
    },
    {
      label: "Report",
      key: "Report",
      icon: <LoginOutlined />,
      children: [
        { label: "Sales Report", key: "report", path: "/user/report" },
        {
          label: "Shipping Report",
          key: "shipping-dashboard",
          path: "/user/shipping-dashboard",
        },
        {
          label: "Return Report (Principle)",
          key: "return-dashboard",
          path: "/user/return-dashboard",
        },
        { label: "HPP Report", key: "hpp-report", path: "/user/hpp-report" },
        {
          label: "Stock Report",
          key: "stock-report",
          path: "/user/stock-report",
        },
      ],
    },
  ],

  admin: [
    {
      label: "",
      key: "notifications",
      icon: <BellOutlined />,
      path: "/user/notification",
    },
    {
      label: "Dashboard",
      key: "dashboard",
      icon: <DashboardOutlined />,
      path: "/user/dashboard",
    },
    {
      label: "Manage Member",
      key: "users",
      path: "/user/users",
      icon: <UsergroupAddOutlined />,
    },
    {
      key: "change-password",
      label: "Change Password",
      path: "/user/change-password",
      icon: <LoginOutlined />,
    },
    {
      label: "Shipping",
      key: "shipping-menu",
      icon: <CarOutlined />,
      children: [
        { label: "Create Shipping", key: "create-shipping", path: "/user/create-shipping" },
        { label: "Create Mutate / Return", key: "mutate-shipping", path: "/user/mutate-shipping" },
        { label: "Return (Principle)", key: "return-principle", path: "/user/return-principle" },
      ],
    },
    {
      key: "generate-barcode",
      label: "Generate Barcode",
      path: "/user/generate-barcode",
      icon: <BarcodeOutlined />,
    },
    {
      label: "Report",
      key: "Report",
      icon: <LoginOutlined />,
      children: [
        { label: "Sales Report", key: "report", path: "/user/report" },
        {
          label: "Shipping Report",
          key: "shipping-dashboard",
          path: "/user/shipping-dashboard",
        },
        {
          label: "Return Report (Principle)",
          key: "return-dashboard",
          path: "/user/return-dashboard",
        },
        { label: "HPP Report", key: "hpp-report", path: "/user/hpp-report" },
        {
          label: "Stock Report",
          key: "stock-report",
          path: "/user/stock-report",
        },
        // Alert Report injected dynamically
      ],
    },
  ],

  internaladmin: [
    {
      label: "Manage Member",
      key: "users",
      path: "/user/users",
      icon: <UsergroupAddOutlined />,
    },
    {
      label: "Shipping",
      key: "shipping-menu",
      icon: <CarOutlined />,
      children: [
        { label: "Create Shipping", key: "create-shipping", path: "/user/create-shipping" },
        { label: "Create Mutate / Return", key: "mutate-shipping", path: "/user/mutate-shipping" },
        { label: "Return (Principle)", key: "return-principle", path: "/user/return-principle" },
      ],
    },
    {
      key: "generate-barcode",
      label: "Generate Barcode",
      path: "/user/generate-barcode",
      icon: <BarcodeOutlined />,
    },
    {
      label: "Report",
      key: "Report",
      icon: <LoginOutlined />,
      children: [
        { label: "Sales Report", key: "report", path: "/user/report" },
        {
          label: "Shipping Report",
          key: "shipping-dashboard",
          path: "/user/shipping-dashboard",
        },
        {
          label: "Return Report (Principle)",
          key: "return-dashboard",
          path: "/user/return-dashboard",
        },
        { label: "HPP Report", key: "hpp-report", path: "/user/hpp-report" },
        {
          label: "Stock Report",
          key: "stock-report",
          path: "/user/stock-report",
        },
      ],
    },
  ],
  logistikadmin: [
    {
      label: "Shipping",
      key: "shipping-menu",
      icon: <CarOutlined />,
      children: [
        { label: "Create Shipping", key: "create-shipping", path: "/user/create-shipping" },
        { label: "Create Mutate / Return", key: "mutate-shipping", path: "/user/mutate-shipping" },
        { label: "Return (Principle)", key: "return-principle", path: "/user/return-principle" },
        { label: "Shipping List", key: "shipping", path: "/user/shipping" },
        { label: "Shipping Report", key: "shipping-dashboard", path: "/user/shipping-dashboard" },
      ],
    },
  ],
  gudangadmin: [
    {
      label: "Shipping",
      key: "shipping-menu",
      icon: <CarOutlined />,
      children: [
        { label: "Create Shipping", key: "create-shipping", path: "/user/create-shipping" },
        { label: "Create Mutate / Return", key: "mutate-shipping", path: "/user/mutate-shipping" },
        { label: "Return (Principle)", key: "return-principle", path: "/user/return-principle" },
        { label: "Shipping List", key: "shipping", path: "/user/shipping" },
      ],
    },
  ],
};

const adminDatabaseMenu = (userData) =>
  userData?.roles?.includes("admin") ||
  userData?.roles?.includes("internaladmin")
    ? [
        {
          label: "Item",
          children: [
            { label: "Color", key: "color", path: "/user/color" },
            { label: "Brand", key: "brand", path: "/user/brand" },
            { label: "Category", key: "category", path: "/user/category" },
            {
              label: "SubCategory",
              key: "subcategory",
              path: "/user/subcategory",
            },
            { label: "Division", key: "division", path: "/user/division" },
            { label: "Type", key: "type", path: "/user/type" },
            { label: "Principle", key: "principle", path: "/user/principle" },
            { label: "Article", key: "article", path: "/user/article" },
            { label: "Barcode", key: "barcode", path: "/user/barcode" },
            { label: "Generate Barcode", key: "generate-barcode", path: "/user/generate-barcode" },
          ],
        },
        // Only show Store option for specific usernames
        ...(userData?.username && ["leo", "Merry", "Mary"].includes(userData.username)
          ? [
              {
                label: "Store",
                children: [
                  { label: "Dept", key: "dept", path: "/user/dept" },
                  { label: "Counter", key: "counter", path: "/user/counter" },
                ],
              },
            ]
          : []),
        {
          label: "Promo",
          children: [
            { label: "Diskon", key: "discount", path: "/user/discount" },
          ],
        },
      ]
    : [];

// NOTE: Removed "Stock Not In Opname" and "Opname Summary" from here
const databaseMenu = (userData) => ({
  label: "Database",
  key: "Database",
  icon: <DatabaseOutlined />,
  children: [
    ...adminDatabaseMenu(userData),
    // Hide transaction page for arearep users
    ...(userData?.roles?.includes("arearep") 
      ? [] 
      : [{ label: "Transaction", key: "transaction", path: "/user/transaction" }]
    ),
    { label: "Shipping", key: "shipping", path: "/user/shipping" },
    { label: "Stock", key: "stock", path: "/user/stock" },
    ...(userData?.username === "leo"
      ? [{ label: "Problematic History", key: "problematic-history", path: "/user/problematic-history" }]
      : []),
    ...(userData?.counterCode === "ECOMMRI"
      ? [
          {
            label: "Alert Warning",
            key: "alert-warning",
            path: "/user/alert-warning",
          },
        ]
      : []),
  ],
});

const ecomMenu = (userData) =>
  userData?.counterCode === "ECOMMRI"
    ? [
        {
          label: "Create Ecom Transaction",
          key: "create-transaction-ecom",
          path: "/user/create-transaction-ecom",
          icon: <LoginOutlined />,
        },
        {
          label: "Ecom Dashboard",
          key: "ecom-dashboard",
          path: "/user/ecom-dashboard",
          icon: <LoginOutlined />,
        },
        {
          label: "SKU Validation",
          key: "sku-validation",
          path: "/user/sku-validation",
          icon: <LoginOutlined />,
        },
        {
          label: "SKU Edit",
          key: "sku-edit",
          path: "/user/sku-edit",
          icon: <LoginOutlined />,
        },
        {
          label: "Product Type Validation",
          key: "pt-validation",
          path: "/user/pt-validation",
          icon: <LoginOutlined />,
        },
      ]
    : [];

export const buildMenuItems = (userData, handleLogout) => {
  const allowedUsers = ["leo", "leo_mri", "MerryMRI", "Merry", "Mary", "Yonathan",'MaryMRI']; // <--- keep here
  const allowedAdjustUsers = ["leo", "leo_mri", "Yonathan", "Mary", "MerryMRI", "Merry",'MaryMRI', "Lidya", "Siti", "Rusmono", "RusmonoMri", "Angga"]; // Users who can see troubled transactions

  const roleMenus =
    userData?.roles?.flatMap((role) => MENU_CONFIG[role] || []) || [];

  // De-duplicate by key (keep this!)
  const dedupedRoleMenus = Array.from(
    new Map(roleMenus.map((item) => [item.key, item])).values()
  );

  // Patch children for ECOMMRI Alert Report and Troubled Transactions (keep this!)
  const patchedRoleMenus = dedupedRoleMenus.map((item) => {
    if (item.key === "Report" && Array.isArray(item.children)) {
      const children = [...item.children];

      if (
        userData?.counterCode === "ECOMMRI" &&
        !children.find((c) => c.key === "alert-report")
      ) {
        children.push({
          label: "Alert Report",
          key: "alert-report",
          path: "/user/alert-report",
        });
      }

      // Add troubled transactions menu for allowed users and MRI users
      const isMRIUser = userData?.username?.toLowerCase().includes('mri') || 
                       userData?.counterCode === "ECOMMRI";
      
      if (
        (allowedAdjustUsers.includes(userData?.username) || isMRIUser) &&
        !children.find((c) => c.key === "troubled-transactions")
      ) {
        children.push({
          label: "Penjualan Bermasalah Report",
          key: "troubled-transactions",
          path: "/user/troubled-transactions",
        });
      }

      return { ...item, children };
    }
    return item;
  });

  // Helper: who can see Stock Opname menu?
  const canSeeOpname =
    allowedUsers.includes(userData?.username) ||
    userData?.roles?.includes("admin") ||
    userData?.roles?.includes("internaladmin") ||
    userData?.roles?.includes("office");

  // --- Inject the username-based menu here ---
  let conditionalMenus = [];
  if (allowedUsers.includes(userData?.username)) {
    if (userData?.username !== "Yonathan") {
      conditionalMenus.push({
        label: "Stock Opname",
        key: "stock-opname",
        path: "/user/stock-opname",
        icon: <LoginOutlined />,
      });
    }

    conditionalMenus.push({
      label: "Stock Opname History",
      key: "stock-opname-history",
      path: "/user/stock-opname-history",
      icon: <LoginOutlined />,
    });
  }

  // --- NEW: Move Opname Summary & Stock Not In Opname here ---
  const opnameMenuBlock = canSeeOpname
    ? {
        label: "Stock Opname",
        key: "stock-opname-group",
        icon: <LoginOutlined />,
        children: [
          { label: "Opname Summary", key: "opname-summary", path: "/user/opname-summary" },
          {
            label: "Stock Not In Opname",
            key: "stock-not-in-opname",
            path: "/user/stock-not-in-opname",
          },
        ],
      }
    : null;

  // Build the final menu array
  return [
    ...patchedRoleMenus,
    ...conditionalMenus, // inject here!
    // opnameMenuBlock, // <-- now lives in buildMenuItems (moved from databaseMenu)
    ...(!userData?.roles?.includes("gudangadmin") &&
      !userData?.roles?.includes("logistikadmin") 
      ? [databaseMenu(userData)] 
      : []),
    ...ecomMenu(userData),
    {
      key: "logout",
      label: "Logout",
      icon: <LogoutOutlined />,
      onClick: handleLogout,
    },
  ].filter(Boolean);
};